<template>
<b-modal id="depModal" modal-class="client-details-modal" centered size="lg" hide-footer no-close-on-backdrop hide-header-close @hidden="resetForm">
    <template #modal-header>
        <div class="view-clients-header">
            <b-button variant="close-btn close-option" @click="closeModal">
                <i class="fas fa-times"></i>
            </b-button>
        </div>
    </template>

    <b-container fluid>
        <div class="form-part">
            <div class="title-text text-center mb-3">
                <h5><strong>{{ isEdit ? 'Edit' : 'Add New' }} Dependent</strong></h5>
                <hr />
            </div>
            <form @submit.prevent="submitNote">
                <div class="mb-4">
                    <div class="row">
                        <div class="col-4">
                            <label for="firstName">First Name <span class="text-danger">*</span></label>
                            <b-form-input id="firstName" v-model="dependent.d_fname" class="memberSearch-field mt-2" placeholder="Enter first name" required />
                        </div>

                        <div class="col-4">
                            <label for="middleName">Middle Name</label>
                            <b-form-input id="middleName" v-model="dependent.d_mname" class="memberSearch-field mt-2" placeholder="Enter middle name" />
                        </div>

                        <div class="col-4">
                            <label for="lastName">Last Name <span class="text-danger">*</span></label>
                            <b-form-input id="lastName" v-model="dependent.d_lname" class="memberSearch-field mt-2" placeholder="Enter last name" required />
                        </div>

                    </div>

                </div>
                <div class="mb-4">
                    <div class="row">
                        <div class="col-4">
                            <label for="relation">Relation <span class="text-danger">*</span></label>
                            <b-form-select id="relation" v-model="dependent.d_relate" :options="relationOptions" class="memberSearch-field mt-2" required />
                        </div>
                        <div class="col-4">
                            <label for="gender">Gender <span class="text-danger">*</span></label>
                            <b-form-select id="gender" v-model="dependent.d_gender" :options="genderOptions" class="memberSearch-field mt-2" required />
                        </div>

                        <div class="col-4">
                            <label for="dob">Date of Birth <span class="text-danger">*</span></label>
                            <date-picker 
                                :class="'date-picker-text'" 
                                input-class="info-field memberSearch-field mt-2" 
                                placeholder="" 
                                type="date" 
                                id="birthdate" 
                                v-model="dependent.d_dob" 
                                value-type="format" 
                                format="MM/DD/YYYY"
                                :disabled-date="(date) => date > new Date()">
                            </date-picker>
                        </div>
                    </div>
                </div>

                <!--<div class="mb-4">
                    <div class="col-4">
                        <label for="ssn">SSN <span class="text-danger">*</span></label>
                        <b-form-input id="ssn" v-model="dependent.d_ssn" class="memberSearch-field mt-2" placeholder="Enter SSN" required />
                    </div>
                </div> 
                
                <div class="mb-4">
                    <div class="row">
                        <div class="col-2">
                            <label for="d_option">Instant</label>
                            <input type="radio" value="instant" v-model="dependent.d_option" class="radio-input pl-2" />
                        </div>
                        <div class="col-2">
                            <label for="d_option">For Later</label>
                            <input type="radio" value="later" v-model="dependent.d_option" class="radio-input" />
                        </div>

                    </div>
                </div>
                <div class="mb-4" v-if="dependent.d_option === 'later'"> 
                    {{minEffectiveDate}}
                        <div class="col-4">
                            <label for="new_effective_date">New Effective Date</label>
                            <b-form-input id="new_effective_date" v-model="dependent.new_effective_date" class="memberSearch-field mt-2" type="date" 
                            :min="minEffectiveDate" />
                        </div>
                </div> 

                <div class="mb-4">
                    <div class="row">
                        <div class="col-4" v-if="dependentRequirement.height">
                            <label for="dhrq">Height (feet)</label>
                            <b-form-input id="dhrq" v-model="dependent.dhrq" class="memberSearch-field mt-2" type="number" />
                        </div>
                        <div class="col-4" v-if="dependentRequirement.height">
                            <label for="dhrq2">Height (inch)</label>
                            <b-form-input id="dhrq2" v-model="dependent.dhrq2" class="memberSearch-field mt-2" type="number" />
                        </div>

                        <div class="col-4" v-if="dependentRequirement.weight">
                            <label for="dwrq">Weight (lbs)</label>
                            <b-form-input id="dwrq" v-model="dependent.dwrq" class="memberSearch-field mt-2" type="number" />
                        </div>
                    </div>
                </div> -->

                <div class="mb-4">
                    <label for="notes">Notes</label>
                    <b-form-textarea id="notes" v-model="dependent.d_notes" class="memberSearch-field mt-2" placeholder="Enter notes" rows="3" width="100%" />
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button type="submit" class="btn btn-email-send custom-update-btn" :disabled="isSubmitting" @click="submit">
                        <span v-if="isSubmitting" class="spinner-border spinner-border-sm me-1"></span>
                        {{ isEdit ? 'Update' : 'Submit' }}
                    </button>
                </div>
            </form>
        </div>
    </b-container>
</b-modal>
</template>

<script>
import axios from 'axios';
import {
    tierList
} from '@/utils/constant';
import moment from "moment";
import Helper from '../../../resource/Helper';

const genderList = [{
        value: "",
        text: "Select Gender"
    },
    {
        value: "0",
        text: "Male"
    },
    {
        value: "1",
        text: "Female"
    },
];

const relationshipList = [{
        value: "",
        text: "Select Relation"
    },
    {
        value: "S",
        text: "Spouse"
    },
    {
        value: "C",
        text: "Child"
    },
];

export default {
    name: "DependentModal",
    props: {
        selectedDependent: {
            required: false,
            default: [],
        },
        dependentRequirement: {
            required: true
        },
        tier: {
            required: true
        },
        groupInformation: {
            required: true
        },
        dependentList: {
            required: true
        }
    },
    data() {
        return {
            dependent: {
                d_mname: "",
                d_fname: "",
                d_lname: "",
                d_notes: null,
                d_relate: "",
                d_gender: "",
                d_ssn: "",
                d_dob: "",
                policy_id: "",
                dhrq: null,
                dhrq2: null,
                dwrq: null,
                healthQuestionnaires: [],
                health_notes: "",
                login_user_id: "",
                did: "",
                group: "",
                d_option: "instant",
                new_effective_date: "",
            },
            dependentListsNotInPolicy: [],
            allTiers: tierList,
            minEffectiveDate: '',
            genderOptions: [...genderList],
            relationOptions: [...relationshipList],
            isEdit: false,
            isSubmitting: false,
            spouseCount: 0
        };
    },
    methods: {
        convertDateFormat(dateStr) {
            const [month, day, year] = dateStr.split('-');
            return `${month}/${day}/${year}`;
        },
        convertDate(dateStr) {
            const date = new Date(dateStr);
            return `${(date.getMonth()+1).toString().padStart(2,'0')}/${date.getDate().toString().padStart(2,'0')}/${date.getFullYear().toString().slice(-2)}`;
        },
        setDependent(dependent = null) {
            if (dependent) {
                console.log("dependent", dependent);
                this.dependent.d_fname = dependent.first_name
                this.dependent.d_mname = dependent.middle_name
                this.dependent.d_lname = dependent.last_name
                this.dependent.d_notes = dependent.notes
                this.dependent.d_relate = relationshipList.find((item) => item.text === dependent.relationship).value
                this.dependent.d_gender = genderList.find((item) => item.text === dependent.gender).value
                this.dependent.d_dob = dependent.birthdate_full
                this.dependent.policy_id = dependent.policy_id
                this.dependent.did = dependent.dependent_id
                this.dependent.d_option = "instant"
                this.dependent.new_effective_date = ""
                this.dependent.d_notes = dependent.d_notes
            }
        },

        async getHealthQuestionnaires() {
            console.log("Getting health questionnaires");
            let params = `?policy_id=${this.policyId}`;
            if (this.selectedDependent & this.selectedDependent.dependent_id) {
                params += `&dep_id=${this.selectedDependent.dependent_id}`;
            }
            const url = `${process.env.VUE_APP_API_ADMIN}/api/v2/policy/get-health-questions${params}`;
            try {
                const {
                    data: {
                        data
                    }
                } = await axios.get(url,{      
                      headers: {
                        "X-Internal-Token": Helper.nueraProtectedApiToken(),
                    }
                });
                console.log("health questions", data)
                this.healthQuestionnaires = data.healthQuestionnaires
            } catch (error) {
                this.healthQuestionnaires = [];
                console.log(error);
            }
        },

        async getDependents() {
            if (!this.isEdit) {
                console.log("policy id is ", this.policyId)
                const url = `${process.env.VUE_APP_API_ADMIN}/api/v2/policy/get-dependent-list/${this.policyId}`;
                axios
                    .get(url, {
                        headers: {
                            "X-Internal-Token": Helper.nueraProtectedApiToken(),
                        }
                    })
                    .then((res) => {
                        const {
                            min_effective_date,
                            ...dependentListsNotInPolicy
                        } = res.data.data;
                        this.dependentListsNotInPolicy = Object.values(dependentListsNotInPolicy);
                        this.minEffectiveDate = moment(min_effective_date).format("MM/DD/YYYY");
                    })
                    .catch((error) => {
                        this.handleError(error);
                    });
            }
        },
        async create() {
            delete this.dependent.did;
            let url = `${process.env.VUE_APP_API_ADMIN}/api/v2/policy/create-dependent`;
            try {
                const response = await axios.post(url, this.dependent,{
                    headers: {
                        "X-Internal-Token": Helper.nueraProtectedApiToken(),
                    }
                })
                this.$bvModal.hide('depModal');
                this.$emit('reloadInfo');
                this.$notify(response.data.message);
                console.log(response);
                this.isEdit = false;  // Reset edit mode
                this.resetForm();
            } catch (error) {
                this.isSubmitting = false;
                console.log(error);
                let errMsg = error.response.data.message;
                console.log(errMsg)
                this.$notify(errMsg, "error","danger");
            }
        },

        async update() {
            console.log("Updating dependent");
            console.log(this.dependent);
            let url = `${process.env.VUE_APP_API_ADMIN}/api/v2/policy/update-dependent`;
            try {
                const response = await axios.put(url, this.dependent,{
                    headers: {
                        "X-Internal-Token": Helper.nueraProtectedApiToken(),
                    }
                })
                this.$bvModal.hide('depModal');
                this.$emit('reloadInfo');
                this.$notify(response.data.message);
                this.isEdit = false;  // Reset edit mode
                this.resetForm();
            } catch (error) {
                this.isSubmitting = false;
                let errMsg = error.response.data.message;
                this.$notify(errMsg, "error","danger");
            }
        },

        submit() {
            // Validate required fields
            const requiredFields = {
                'd_fname': 'First Name',
                'd_lname': 'Last Name',
                'd_relate': 'Relation',
                'd_gender': 'Gender',
                'd_dob': 'Date of Birth'
            };

            const missingFields = [];
            
            for (const [field, label] of Object.entries(requiredFields)) {
                if (!this.dependent[field]) {
                    missingFields.push(label);
                }
            }

            if (missingFields.length > 0) {
                this.$notify(`Please fill in the following required fields: ${missingFields.join(", ")}`, 'error','danger');
                return;
            }

            // If validation passes, proceed with submission
            this.isSubmitting = true;
            this.dependent.group = this.groupInformation.group_name
            this.dependent.login_user_id = this.groupInformation.group_id;
            this.dependent.policy_id = this.policyId
            if (!this.isEdit) {
                this.create();
            } else {
                this.update();
            }
        },
        getDependentOptions(tier) {
            console.log("All tiers", this.allTiers);
            console.log("Getting dependent options");
            console.log(tier);

            const childOption = {
                text: "Child",
                value: "C",
            };
            const spouseOption = {
                text: "Spouse",
                value: "S",
            };
            const spouse = this.dependentList && this.dependentList.length ?
                this.dependentList.filter((item) => item.relationship === "Spouse") : [];

            this.spouseCount = spouse.length;

            if (tier == this.allTiers.io) {
                this.relationOptions = [childOption, spouseOption];
            } else if (tier == this.allTiers.ic) {
                this.relationOptions = [childOption, spouseOption];
            } else if (tier == this.allTiers.is) {
                this.relationOptions = [childOption, spouseOption];
            } else if (tier == this.allTiers.if) {
                this.relationOptions = [childOption, spouseOption];
            }

        },
        addMedication(questionnaire) {
            questionnaire.medMedications.push({
                dosage: "",
                medical_condition: "",
                medication: "",
            });
        },
        closeModal() {
            this.$emit("onClosedModal");
            this.$bvModal.hide("depModal");
            this.resetForm();
        },
        resetForm() {
            this.isEdit = false;  // Reset edit mode
            this.selectedDependent = null;
            this.isSubmitting = false;
            this.clearForm();
        },
        clearForm() {
            this.dependent = {
                d_mname: "",
                d_fname: "",
                d_lname: "",
                d_notes: null,
                d_relate: "",
                d_gender: "",
                d_ssn: "",
                d_dob: "",
                policy_id: "",
                dhrq: null,
                dhrq2: null,
                dwrq: null,
                healthQuestionnaires: [],
                health_notes: "",
                login_user_id: "",
                did: "",
                group: "",
                d_option: "instant",
                new_effective_date: "",
            };
        },
    },
    computed: {
        policyId() {
            return this.$route.params.policyId;
        },
        isHealthPlan() {
            return this.dependentRequirement && this.dependentRequirement.healthQuestions
        },
        loginUserId() {
            return this.$store.getters.userId;
        },
    },
    watch: {
        selectedDependent: {
            handler: function (val) {
                if (val && val.dependent_id) {
                    console.log("Selected dependent", val);
                    this.isEdit = true;
                    this.setDependent(val);
                    this.getDependentOptions(this.tier);
                }
                else {
                    this.isEdit = false;
                    this.clearForm();
                }
            },
            deep: true,
        },
        tier: function (val) {
            if (val == null) return;
            this.getDependentOptions(val);
        },
    },
    mounted() {
        console.log("Route params:", this.$route.params);
        console.log("Raw policyId:", this.$route.params.policyId);
        console.log("Decoded policyId:", this.policyId);
        console.log(this.policyId);
        this.getDependents();
        // this.getHealthQuestionnaires();
    }
};
</script>

<style>
.custom-update-btn {
  background-color: #1392b8 !important; /* or any color you want */
  color: white;
  border: none;
}

.custom-update-btn:hover {
  background-color: #1392b8;
}

.memberSearch-field {
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: calc(1.5em + 0.75rem + 2px);
}
.info-field{
    width: 100%;
    height: 39px;
    border: 1px solid #dce1e7;
    outline: none;
    border-radius: 6px;
    padding: 9px 15px;
    font-size: 14px;
    transition: all ease 0.6s;
}

.date-picker-text {
    width: 100% !important;
}
</style>